import { memo } from 'react';
import { DataTreeProps } from 'shared/data_tree/DataTree';
import { DataTreeNode } from 'shared/data_tree/DataTreeNode';
import { TreeNode, TreeNodeId } from 'shared/data_tree/types';

export type DataTreeNodesProps<TData> = Readonly<
    Omit<DataTreeProps<TData>, 'data'> & {
        nodes: TreeNode<TData>[];
        parentNodeId?: TreeNodeId;
    }
>;

function DataTreeNodes<TData>({
    treeId,
    nodes,
    parentNodeId,
    renderNode,
    expandable,
    selectable,
    movable,
    scrollToNodeId,
    isTreeLoading,
    onNodeRef,
}: DataTreeNodesProps<TData>) {
    return (
        <>
            {nodes.map((node) => (
                <DataTreeNode<TData>
                    key={node.id}
                    treeId={treeId}
                    node={node}
                    parentNodeId={parentNodeId}
                    renderNode={renderNode}
                    expandable={expandable}
                    selectable={selectable}
                    movable={movable}
                    scrollToNodeId={scrollToNodeId}
                    isTreeLoading={isTreeLoading}
                    onNodeRef={onNodeRef}
                />
            ))}
        </>
    );
}

const memoDataTreeNodes = memo(DataTreeNodes) as typeof DataTreeNodes;
export { memoDataTreeNodes as DataTreeNodes };
